<template>
    <div>
        <div class="header" v-if="certified == '1'">
            <img src="~@/assets/images/69.png" alt="" class="header_logo">
            <span class="header_title">入驻待审核</span>
        </div>
        <div class="header2" v-if="certified == '3'">
            <img src="~@/assets/images/70.png" alt="" class="header_logo">
            <span class="header_title">入驻审核失败</span>
            <span class="header_reason">{{ shopData.reason }}</span>
            <el-button type="primary" size="small" @click="handleRetry">重新提交</el-button>
        </div>
        <div class="header3" v-if="certified == '5'">
            <img src="~@/assets/images/71.png" alt="" class="header_logo">
            <span class="header_title">入驻审核成功</span>
        </div>
        <div>
            <div class="section">
                <div class="section-header">
                    <span class="section-title">实名信息</span>
                </div>
                <div class="section-body">
                    <div class="info-row">
                        <div class="info-item">
                            <label>姓名</label>
                            <div class="info-value">{{ shopData.contacts_name }}</div>
                        </div>
                        <div class="info-item">
                            <label>手机号</label>
                            <div class="info-value">{{ shopData.contacts_phone }}</div>
                        </div>
                    </div>

                    <div class="info-row">
                        <div class="info-item full-width">
                            <label>身份证号</label>
                            <div class="info-value">{{ shopData.idcard_no }}</div>
                        </div>
                    </div>

                    <div class="info-row">
                        <div class="info-item">
                            <label>身份证人像面</label>
                            <div class="image-preview">
                                <img :src="shopData.idcard_front" alt="身份证人像面" />
                            </div>
                        </div>
                        <div class="info-item">
                            <label>身份证国徽面</label>
                            <div class="image-preview">
                                <img :src="shopData.idcard_reverse" alt="身份证国徽面" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 店铺信息 -->
            <div class="section">
                <div class="section-header">
                    <span class="section-title">店铺信息</span>
                </div>
                <div class="info-row">
                    <div class="info-item full-width">
                        <label>店铺名称</label>
                        <div class="info-value select-value">{{ shopData.store_name }}</div>
                    </div>
                </div>

                <div class="section-body">
                    <div class="info-row">
                        <div class="info-item">
                            <label>店铺LOGO</label>
                            <div class="image-preview small">
                                <img :src="shopData.store_logo" alt="店铺LOGO" />
                            </div>
                        </div>
                        <div class="info-item">
                            <label>店铺背景</label>
                            <div class="image-preview small">
                                <img :src="shopData.store_backdrop" alt="店铺LOGO" />
                            </div>
                        </div>
                    </div>

                    <div class="info-row">
                        <div class="info-item">
                            <label>店铺类型</label>
                            <div class="info-value select-value">{{ shopData.run_type }}</div>
                        </div>
                    </div>

                    <div class="info-row">
                        <div class="info-item">
                            <label>主营行业</label>
                            <div class="info-value select-value">{{ shopData.main_industry }}</div>
                        </div>
                        <div class="info-item">
                            <label>店铺所在地</label>
                            <div class="info-value select-value">{{ shopData.store_province_name +
                                shopData.store_city_name + shopData.store_district_name }}</div>
                        </div>
                    </div>

                    <div class="info-row">
                        <div class="info-item full-width">
                            <label>店铺详细地址</label>
                            <div class="info-value textarea-value">{{ shopData.store_address }}</div>
                        </div>
                    </div>

                    <div class="info-row">
                        <div class="info-item full-width">
                            <label>店铺简介</label>
                            <div class="info-value textarea-value">{{ shopData.store_introduce }}</div>
                        </div>
                    </div>

                    <div class="info-row">
                        <div class="info-item">
                            <label>店铺资质</label>
                            <div class="image-preview-list">
                                <div class="image-preview small" v-for="(item, index) in shopData.shop_qualifications">
                                    <img :src="item" alt="" :key="index" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ShopWaiting',
    props: {
        certified: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            shopData: {

            }
        };
    },
    mounted() {
        this.fetchReviewInfo();
    },
    methods: {
        handleRetry() {
            this.$emit('goToComponent', 'ShopAuthentication', { certified: '3' });
        },
        fetchReviewInfo() {
            this.$api.getShopReviewInfo().then(res => {
                this.shopData = res;
            }).catch(err => {
                this.$message.error(err);
            });
        }
    }
};
</script>

<style scoped>
.content {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    padding: 30px;
    margin: 20px;
}

.header {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(to bottom, #fff1e0, #FFFFFF);
    padding: 32px 0;
}

.header2 {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(to bottom, #FFE6E8, #FFFFFF);
    padding: 32px 0;
}

.header3 {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(to bottom, #E9F8EE, #FFFFFF);
    padding: 32px 0;
}

.header_logo {
    width: 78px;
    height: 56px;
}

.header_title {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    margin-top: 16px;
}

.header_reason {
    font-size: 14px;
    color: #333333;
    margin: 16px;
}

.section {
    margin-bottom: 30px;
}

.section-header {
    margin-top: 20px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    text-align: left;
}

.section-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    padding-left: 10px;
    border-left: 4px solid #286CED;
}

.section-body {
    padding: 0 10px;
}

.info-row {
    display: flex;
    margin-bottom: 20px;
    flex-wrap: wrap;
}

.info-item {
    flex: 1;
    min-width: 300px;
    margin-right: 20px;
    text-align: left;
}

.info-item.full-width {
    flex: 0 0 100%;
    margin-right: 0;
}

.info-item label {
    display: block;
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
}

.info-value {
    font-size: 16px;
    color: #333;
    padding: 8px 12px;
    background-color: #F5F5F5;
    border-radius: 4px;
    height: 36px;
    display: flex;
    align-items: center;
}

.info-value.textarea-value {
    height: auto;
    align-items: flex-start;
    padding: 12px;
}

.info-value.select-value {
    background-color: #F5F5F5;
    cursor: default;
}

.info-text {
    margin-top: 8px;
    font-size: 14px;
    color: #333;
    text-align: center;
}

.radio-label {
    margin-right: 20px;
    cursor: default;
}

.radio-label input[type="radio"] {
    margin-right: 5px;
}

.image-preview {
    width: 200px;
    height: 140px;
    border: 1px solid #E8E8E8;
    border-radius: 4px;
    overflow: hidden;
}

.image-preview.small {
    width: 120px;
    height: 120px;
}

.image-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.image-preview-list {
    display: flex;
    gap: 10px;
}

.image-preview-list .image-preview {
    margin-right: 10px;
}

.review-status {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px;
    background-color: #FFF7E6;
    border-radius: 8px;
    margin-top: 40px;
}

.status-icon {
    font-size: 48px;
    color: #FF7D00;
    margin-right: 20px;
}

.status-text {
    text-align: left;
}

.status-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin: 0 0 8px 0;
}

.status-desc {
    font-size: 14px;
    color: #666;
    margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .content {
        padding: 20px;
        margin: 10px;
    }

    .info-row {
        flex-direction: column;
    }

    .info-item {
        margin-right: 0;
        margin-bottom: 20px;
        min-width: auto;
    }

    .review-status {
        flex-direction: column;
        text-align: center;
    }

    .status-icon {
        margin-right: 0;
        margin-bottom: 15px;
    }

    .status-text {
        text-align: center;
    }

    .image-preview-list {
        flex-wrap: wrap;
    }
}
</style>